function ApplySelectionLimits(element) {
    if (element) {
        element.selectize({
            plugins: ['remove_button'],
            maxItems: !element.data("limit") ? null : parseInt(element.data("limit"))
        });
    }
}

function ClearInput(index, input) {
    input = $(input);
    if (input && input[0].selectize) {
        input[0].selectize.clear();
    }
    else {
        if (input.is(':checkbox')) {
            input.prop('checked', false);
        }
        else {
            input.val("");
        }
    }
}

function isSuggestedFieldInfoMissing() {
    var infoMissing = false;
    $("input.suggested, select.suggested").not("[name*='_number_']").each(function () {
        if (!infoMissing && ($(this).val() == null || $(this).val() === "")) {
            infoMissing = true;
        }
    });
    return infoMissing;
}

function GetCustomFieldValues(baseElement, includeFalseValues = false) {

    var customFieldValues = {};
    baseElement.find($('[id*="CustomField"]')).each(function () {

        var val;
        if ($(this).is(":checkbox")) {
            val = $(this).is(":checked");
        }
        else {
            val = $(this).val();
        }

        // Multi Select Custom Fields
        if (Array.isArray(val)) {
            val = val.join(";");
        }

        if (!val && !includeFalseValues) {
            return;
        }

        var htmlId = $(this).attr("id");
        var customFieldId = htmlId.substring(htmlId.indexOf("CustomField_") + 12);

        customFieldValues[customFieldId] = {
            CustomFieldId: customFieldId,
            Value: val
        };
    });


    var groupedCustomFieldFiles = [];
    baseElement.find($('[name*="CustomFieldFile"]')).each(function () {

        var val;
        val = $(this).val();
        console.log(val)

        if (!val && !includeFalseValues) {
            return;
        }

        var id = $(this).attr('name').split('_')[1];

        if (!groupedCustomFieldFiles[id]) {
            groupedCustomFieldFiles[id] = [];
        }

        var fileVal = $(this).prop('defaultValue');

        if (fileVal) {
            groupedCustomFieldFiles[id].push(JSON.parse(decodeURIComponent(fileVal)));
        }
    });

    for (var index in groupedCustomFieldFiles) {
        var element = groupedCustomFieldFiles[index];

        customFieldValues[index] = {
            CustomFieldId: index,
            Value: JSON.stringify(element)
        };
    }

    return customFieldValues;
}

$(function () {
    $(".selectized[name*='CustomField_']").not(".required").bind("change", function () {
        var select = $(this);
        var selectId = select.attr("id");
        var numOptionsSelected = select[0].options.length;

        if (numOptionsSelected === 0) {
            select.before("<input type='hidden' value='' name='" + selectId + "'>");
        }
        else {
            $("input[name=" + selectId + "]").remove();
        }
    });

    jQuery.validator.addMethod("dangerContent", function (value, element) {
        var forbiddenChars = ['<', '>']
        var curentContent = value;

        if (!$(element).hasClass('prevent-danger-content')) {
            return true;
        }

        return forbiddenChars.filter(function (val) { return curentContent.indexOf(val) > -1 }).length == 0;

    }, "Value cannot contain '<' or '>'.");

    $('form .prevent-danger-content').each(function () { $(this).rules("add", "dangerContent"); })
});

